import { useEffect } from 'react';

function PlatformCheck({ setPlatform }) {
  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    let platform = 'Desconhecida';

    if (/Android/i.test(userAgent)) {
      platform = 'Android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      platform = 'iOS';
    } else if (/Mac/i.test(userAgent)) {
      platform = 'Mac';
    } else if (/Windows/i.test(userAgent)) {
      platform = 'Windows';
    } else if (/Linux/i.test(userAgent)) {
      platform = 'Linux';
    } else {
      platform = 'Outra plataforma';
    }

    // Chame a função para definir a plataforma no componente App.js
    setPlatform(platform);
  }, [setPlatform]);

  return null; // Este componente não renderiza nada visível
}

export default PlatformCheck;
